<app-navbar></app-navbar>
<app-sidebar></app-sidebar>
<!-- internal router -->
<div id="content-wrapper">
    <div class="container-fluid">
        <div class="page_box">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>